import { render, staticRenderFns } from "./DevicesList.vue?vue&type=template&id=45b89342&scoped=true&"
import script from "./DevicesList.vue?vue&type=script&lang=js&"
export * from "./DevicesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b89342",
  null
  
)

export default component.exports